import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { withCallState } from '@shared/store-features/call-state-feature.ts';
import { SeriesState } from '@modules/entertainment/pages/series/store/series.model.ts';
import { seriesSlice } from '@modules/entertainment/pages/series/store/series-slice.ts';
import { episodeSlice } from '@modules/entertainment/pages/series/store/episode-slice.ts';
import { callStateStatusSlice } from '@modules/entertainment/pages/series/store/call-state-status.slice.ts';

const useSeriesStore = create<SeriesState>()(
  devtools(
    (set, getState) => ({
      ...seriesSlice(set, getState),
      ...episodeSlice(set, getState),
      ...withCallState(getState),
      ...callStateStatusSlice(set, getState)
    }),
    { name: 'SeriesStore' }
  )
);

export default useSeriesStore;
